export default (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <circle
      cx="7.98548"
      cy="7.86829"
      r="6.55892"
      stroke="#5E6366"
      strokeWidth="1.4"
    />
    <path
      d="M15.8906 17.0883C16.1558 17.3696 16.5988 17.3826 16.8801 17.1174C17.1614 16.8522 17.1744 16.4092 16.9092 16.1279L15.8906 17.0883ZM11.8735 12.8279L15.8906 17.0883L16.9092 16.1279L12.8921 11.8674L11.8735 12.8279Z"
      fill="#5E6366"
    />
    <rect
      x="11.4258"
      y="7.30859"
      width="1.3"
      height="6.88"
      rx="0.65"
      transform="rotate(90 11.4258 7.30859)"
      fill="#5E6366"
    />
  </svg>
);
